import React, { useContext, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScriptNext,
  Marker,
  Polygon,
} from "@react-google-maps/api";
import TadobaContext from "./Context/TadobaContext";
import { MapKey } from "../Data/Data";

const TigerConflictMap = ({ data }) => {
  const [position, setPosition] = useState(null);
  const [mapRef, setMapRef] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);

  const api = useContext(TadobaContext);

  const handleMapLoad = (map) => {
    setPosition({
      lat: map.latLng.lat(),
      lng: map.latLng.lng(),
    });
  };

  const onLoad = (map) => {
    setMapRef(map);
  };

  const handleDragEnd = () => {
    if (mapRef) {
      const newCenter = mapRef.getCenter();
      setPosition({
        lat: newCenter.lat(),
        lng: newCenter.lng(),
      });
    }
  };

  const triangleAlertIcon = {
    path: "M12 2L1 21H23L12 2Z",
    fillColor: "#FF6B35",
    fillOpacity: 0.9,
    strokeWeight: 1,
    strokeColor: "#D63031",
    scale: 1,
    anchor: { x: 12, y: 21 },
  };

  console.log(data);

  return (
    <div className="Setting_Table">
      <LoadScriptNext googleMapsApiKey={MapKey}>
        <GoogleMap
          mapContainerStyle={{ width: "95%", height: "100%" }}
          center={
            position === null ? { lat: 21.572004, lng: 79.19164 } : position
          }
          zoom={11}
          onClick={handleMapLoad}
          onLoad={onLoad}
          onDragEnd={handleDragEnd}
        >
          {api?.polygonCoordinates && (
            <Polygon
              paths={api.polygonCoordinates}
              options={{
                fillColor: "skyblue",
                fillOpacity: 0.4,
                strokeColor: "blue",
                strokeOpacity: 0.6,
                strokeWeight: 2,
              }}
              onClick={handleMapLoad}
            />
          )}

          {data?.map((item) => (
            <Marker
              key={item.id}
              position={{
                lat: parseFloat(item["Latitude"]),
                lng: parseFloat(item["Longitude"]),
              }}
              icon={triangleAlertIcon}
              onClick={() => setSelectedMarker(item)}
              title={`Conflict ID: ${item.id} - ${item.comments}`}
            />
          ))}

          {selectedMarker && (
            <InfoWindow
              position={{
                lat: parseFloat(selectedMarker.lat),
                lng: parseFloat(selectedMarker.long),
              }}
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div>
                <p>
                  <strong>Date:</strong> {selectedMarker["Conflict Date"]}
                </p>
                <p>
                  <strong>Comments:</strong> {selectedMarker["Comments"]}
                </p>
                <p>
                  <strong>Village:</strong> {selectedMarker["Village"]}
                </p>
                {selectedMarker["Tiger Name"] !== "NA" && (
                  <p>
                    <strong>Tiger Name:</strong> {selectedMarker["Tiger Name"]}{" "}
                    ({selectedMarker["Age"]})
                  </p>
                )}
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
      </LoadScriptNext>
    </div>
  );
};

export default TigerConflictMap;
